const PartnersConf = {
  partners: [
    {
      logo: "behavioralPensions.png",
      title: "Behavioral Pensions",
      href: "https://behavioralpensions.org",
    },
    {
      logo: "Masterbrand-Logo_color.png",
      title: "Startupbootcamp",
      href: "https://www.startupbootcamp.org/",
      key: "startupBootcamp",
    },
    {
      logo: "thinkforwardinitiative.png",
      title: "TFI - Think Forward Initiative",
      href: "https://www.thinkforwardinitiative.com/",
      key: "tfi",
    },
    {
      logo: "masschallenge.png",
      title: "MassChallenge",
      href: "https://masschallenge.org/",
      key: "MassChallenge",
    },
    {
      logo: "beway.png",
      title: "BeWay",
      href: "https://behavioralpensions.org",
    },
    {
      logo: "bankiaFintechInnsomnia.png",
      title: "Bankia Fintech . Insomnia",
      href: "https://www.bankiafintech.com/fintech/es/opseeker.html",
      key: "bankia",
    },
    {
      logo: "santaluciaimpulsa.png",
      title: "Santa Lucía Impulsa",
      href: "http://www.santaluciaimpulsa.es/opseeker/?lang=en",
    },
    {
      logo: "abancaInnovaConector.png",
      title: "Abanca Innova by Conector",
      href: "https://www.conector.com/startups/opseeker/",
      key: "connector",
    },
    {
      logo: "yuzz.png",
      title: "Yuzz Santander (Explorer)",
      href: "https://explorerbyx.org/",
    },
  ],
  clients: [
    {
      logo: "mapfre.png",
      title: "Mapfre",
      href: "https://mapfre.es/",
    },
    {
      logo: "rabobank-logo.png",
      title: "Rabobank",
      href: "https://rabobank.nl/",
    },
    {
      logo: "Fintonic-logo.png",
      title: "Fintonic",
      href: "https://www.fintonic.com/",
    },
    {
      logo: "bankia.svg",
      title: "Bankia",
      href: "https://bankia.es/",
    },
    {
      logo: "santaLucia.png",
      title: "Santa Lucía",
      href: "https://www.santalucia.es/",
    },
    {
      logo: "sabadell.png",
      title: "Sabadell",
      href: "https://sabadell.es/",
    },
    {
      logo: "cajaDeIngenieros.png",
      title: "Caja de Ingenieros",
      href: "https://www.caixaenginyers.com/es/",
    },
    {
      logo: "vivat.png",
      title: "Vivat",
      href: "https://vivat.nl",
    },
  ],
};

export default PartnersConf;



// WEBPACK FOOTER //
// ./src/containers/partners/PartnersConf.js